import React, { useState } from "react";
import { Col, Container, Row, Form, Button, Card } from "react-bootstrap";
import stdnt from "../assets/images/student.png";
import schl from "../assets/images/school.png";
import hsptl from "../assets/images/hospital.png";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { SetUserDetailsToLocal } from "../services/utils";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { authServices } from "../services/auth.services";
import { GetPageTittle } from "../services/utils";
import { useNavigate, Link } from "react-router-dom";
import { showSuccessMessage, showErrorMessage } from "../services/utils";
import RightSidebar from "../components/common-components/right_sidebar";
import LoadingBar from "../components/common-components/toaster/loader/loader";
const Signin = () => {
    const navigate = useNavigate()
    var PageTittle = GetPageTittle()
    const [form, FormData] = useState({"remember":"off"})
    const [pageutils, SetPageUtils] = useState({ loading: false })
    const [showPass, setShowPass] = useState(false)
    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        FormData({
            ...form,
            [name]: value
        })
    }

    const logMeIn = (e) => {
        e.preventDefault()
            SetPageUtils(prev => ({ ...prev, loading: true }))
            const role = PageTittle.toLowerCase()
            form.role = role
            authServices.login(form).then(resp => {
                SetPageUtils(prev => ({ ...prev, loading: false }))
                SetUserDetailsToLocal(resp)
                showSuccessMessage({ message: "Login Successful" })
                PageTittle === "School" ?
                    navigate("/school-dashboard") :
                    PageTittle === "Student" ?
                        navigate("/student-dashboard") :
                        navigate("/hospital-dashboard")
            }).catch(err => {
                showErrorMessage({ message: err.data.errors.msg })
                SetPageUtils(prev => ({ ...prev, loading: false }))
            })
        console.log(form, "<<<<form")
    }

    return (
        <div className="signup_pg">
            <Container fluid>
                {pageutils.loading && < LoadingBar />
                }

                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <div className="signup_form">
                                <div className="sign_hdng">
                                    <h2>Log In</h2>
                                </div>
                                <div className="optn_cards_div">
                                    <Row>
                                        <Col sm={4}>
                                            <div className={PageTittle === 'School' ? `sign_card active` : 'sign_card'} >
                                                <Card className="mb-2">
                                                    <Card.Body>
                                                        {PageTittle === 'School' &&
                                                            <div className="crd_icn">
                                                                <BsFillCheckCircleFill />
                                                            </div>}
                                                        <Card.Img
                                                            src={schl}
                                                            className="me-0"
                                                        />
                                                        <Card.Title>
                                                            School{" "}
                                                        </Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </Col>
                                        <Col sm={4}>
                                            <div className={PageTittle === 'Student' ? `sign_card active` : 'sign_card'}>
                                                <Card className="mb-2">
                                                    <Card.Body>
                                                        {PageTittle === 'Student' &&
                                                            <div className="crd_icn">
                                                                <BsFillCheckCircleFill />
                                                            </div>}
                                                        <Card.Img
                                                            src={stdnt}
                                                            className="me-0"
                                                        />
                                                        <Card.Title>
                                                            Student{" "}
                                                        </Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </Col>
                                        <Col sm={4}>
                                            <div className={PageTittle === 'Hospital' ? `sign_card active` : 'sign_card'}>
                                                <Card className="mb-2">
                                                    <Card.Body>
                                                        {PageTittle === 'Hospital' &&
                                                            <div className="crd_icn">
                                                                <BsFillCheckCircleFill />
                                                            </div>}
                                                        <Card.Img
                                                            src={hsptl}
                                                            className="me-0"
                                                        />
                                                        <Card.Title>
                                                            Hospital{" "}
                                                        </Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <Form className="signform_div" onSubmit={(e) => { logMeIn(e) }}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicPassword"
                                    >
                                        <Form.Label>
                                            Email address
                                        </Form.Label>
                                        <Form.Control
                                            onChange={(e) => { handleChange(e) }}
                                            type="email"
                                            name="email"
                                            required
                                            placeholder="Enter Registered Email address "
                                        />
                                    </Form.Group>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicPassword1"
                                    >
                                        <Form.Label>Password</Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                onChange={(e) => { handleChange(e) }}
                                                type={showPass ? "text" : "password"}
                                                name="password"
                                                placeholder="Enter Password"
                                                required
                                            />
                                            {showPass ? <FaEyeSlash onClick={() => { setShowPass(!showPass) }} className="sign_upPass" /> :
                                                <FaEye onClick={() => { setShowPass(!showPass) }} className="sign_upPass" />}
                                        </div>

                                        <Form.Text className="text-muted">
                                            Minimum 8 characters, at least one
                                            alpha, special, numeric, upper &
                                            lower case
                                        </Form.Text>
                                    </Form.Group>
                                    <div className="rmbr_forgot">
                                        <Form.Group
                                            className="mb-3 d-flex justify-content-between"
                                            controlId="formBasicCheckbox"
                                        >
                                            <Form.Check type="checkbox">

                                                <Form.Check.Input type="checkbox" name="remember" onChange={(e) => {
                                                    console.log(e.target.value,"e.target.value")
                                                    FormData({
                                                        ...form,
                                                        "remember": form.remember==="on"?"off":"on"
                                                    }) }} />

                                                <Form.Check.Label>
                                                    <p className="sign_agree mb-0">
                                                        Remember Me
                                                    </p>
                                                </Form.Check.Label>
                                            </Form.Check>
                                            <p className="sign_agree">
                                                <Link to={`/forgot-password/${PageTittle}`} className="bld_link">
                                                    Forgot Password?
                                                </Link>

                                            </p>
                                        </Form.Group>
                                    </div>
                                    <Button
                                        className="btn_theme w-100 mt-4"
                                        type="submit"
                                        variant=""
                                    >
                                        Log In
                                    </Button>
                                    <p className="sign_agree text-center mt-2">
                                        Don't have an account?{" "}
                                        <span style={{ cursor: "pointer" }} onClick={() => { navigate('/signup') }} className="bld_link">Register here</span>.
                                    </p>
                                </Form>
                            </div>
                        </Col>
                        <RightSidebar />
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default Signin;
